import {Component} from 'react';
import h from 'react-hyperscript';
import './Form.scss';
import {subhead} from 'Components/Typography/Typography';
import TextField from '@material-ui/core/TextField';
import TooltipGroup from 'Components/TooltipGroup/TooltipGroup';

class InputGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isScreenDisabled: false,
      defaultValue: this.props.defaultValue,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setDefaultValue(this.props.defaultValue);
    }
  }

  setDefaultValue(value) {
    this.setState({
      defaultValue: value,
    });
  }

  setScreenDisabled(value) {
    this.setState({
      isScreenDisabled: value,
    });
  }

  render() {
    const {min, max, minLength, maxLength} = this.props;

    if (this.props.prefilled || this.props.disabled) {
      this.setScreenDisabled(true);
    }

    return (
      h('div', {
        className: 'form-group form-group--input',
      }, [
        this.props.tooltip ? h(TooltipGroup, {
          title: this.props.tooltip,
        }, h(subhead, {
          key: 'input',
        }, this.props.label)) : h(subhead, {
          key: 'input',
        }, this.props.label),
        h(TextField, {
          key: this.props.id,
          id: this.props.id,
          name: this.props.id,
          fullWidth: true,
          value: this.state.defaultValue,
          disabled: this.state.isScreenDisabled,
          type: this.props.type,
          onChange: this.props.onChange,
          onBlur: this.props.onBlur || null,
          InputProps: {inputProps: {min, max, minLength, maxLength}},
        }),
      ])
    );
  }
}

export default InputGroup;
